





























































import { Component, Mixins } from 'vue-property-decorator';
import { Mutations, Actions } from '@/ts/store/Constants';
import InputFieldMethods from '@/mixins/InputFieldMethods.vue';

import { Keyboard, KeyboardInfo, KeyboardResize } from '@capacitor/keyboard';

@Component
export default class ChangePassword extends Mixins(InputFieldMethods) {
    public currentPassword = '';
    public newPassword = '';
    public repeatPassword = '';
    private keyboardListenerAdded: boolean = false;

    constructor() {
        super();
        this.initializeKeyboardListener();
    }

    get keyboardVisibleClass() {
        return this.keyboardListenerAdded ? 'overflowY-auto' : '';
    }

    public initializeKeyboardListener(): void {
        Keyboard.setScroll({ isDisabled: false });
        Keyboard.setAccessoryBarVisible({ isVisible: true });
        Keyboard.setResizeMode({
            mode: KeyboardResize.Native,
        });

        Keyboard.addListener('keyboardDidShow', (info: KeyboardInfo) => {
            this.keyboardListenerAdded = true;
            this.scrollToBottom();
        });

        Keyboard.addListener('keyboardDidHide', () => {
            this.keyboardListenerAdded = false;
        });
    }

    get message() {
        let message = '';

        switch (this.responseCode) {
            case 400:
                message = this.$t('user.password-does-not-meet-requirements', 'The new password does not meet the requirements.');
                break;

            case 422:
                message = this.$t('user.incorrect-password', 'Incorrect password.');
                break;
        }

        return message;
    }

    get responseCode() {
        return this.$store.state.User.passwordChangeResponseCode;
    }

    get changingPassword() {
        return this.$store.state.User.changingPassword;
    }

    public dismissDialog() {
        this.$store.commit(Mutations.SHOW_CHANGE_PASSWORD, false);
    }

    public changePassword() {
        this.$validator.validate().then((valid) => {
            if (valid) {
                this.$store.dispatch(Actions.CHANGE_PASSWORD, this.requestData());
            }
        });
    }

    public scrollToBottom() {
        setTimeout(() => {
            const overlay = (this.$refs.overlay as HTMLElement);
            overlay.scrollTop = overlay.scrollHeight - overlay.clientHeight;
        }, 0);
    }

    public requestData() {
        return {
            current: this.currentPassword,
            new: this.newPassword,
        };
    }
}
